import { Suspense } from 'react';
import { getConfig } from '~/org/twilio/one-support-center/shared/osc-env';
import { types as oscEnvTypes } from '~/org/twilio/one-support-center/shared/osc-env';
import { useScript } from '@twiliointernal/org/twilio/e2-commons/shared/hooks';

import { AppProvider } from './providers';
import { initializeRum } from '../lib/rum';

const { realm, recaptchaSiteKey } = getConfig();

initializeRum();

export default (): JSX.Element => {
  // Disable TrustArc in pre-prod environments
  const isTrustArcDisabled = realm !== oscEnvTypes.Realm.prod;
  // Load TrustArc site wide - https://www.trustarc.com/cookie-consent-manager/
  useScript({
    src: 'https://consent.trustarc.com/notice?domain=twilio.com&c=teconsent&gtm=1&js=nj&noticeType=bb',
    disabled: isTrustArcDisabled,
  });
  // Load reCaptcha site wide - https://developers.google.com/recaptcha/docs/v3#placement_on_your_website
  useScript({
    src: `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}&badge=bottomleft`,
  });

  return (
    <Suspense fallback={null}>
      <AppProvider />
    </Suspense>
  );
};
